import buildParams from '../../internal/analytics/buildParams';
import createAnalyticsReporter from '../../internal/analytics/createAnalyticsReporter';
const method = (methodName)=>{
    return (config, eventName, parameters)=>{
        var _config_analytics, _analyticsReporter_methodName;
        if (!config || ((_config_analytics = config.analytics) === null || _config_analytics === void 0 ? void 0 : _config_analytics.disabled)) {
            return;
        }
        const { service, userId, pageViewToken, analytics } = config;
        // Passing only the parameters needed by the 'createAnalyticsReporter' function
        // instead of the spreading the config object to avoid invalidating the cache for
        // unrelated values.
        const analyticsReporter = createAnalyticsReporter({
            service,
            userId,
            pageViewToken,
            parametersAllowList: analytics === null || analytics === void 0 ? void 0 : analytics.parametersAllowList,
            disableCookies: analytics === null || analytics === void 0 ? void 0 : analytics.disableCookies,
            cookieEnforcementMode: analytics === null || analytics === void 0 ? void 0 : analytics.cookieEnforcementMode,
            useLegacyEndpoint: analytics === null || analytics === void 0 ? void 0 : analytics.useLegacyEndpoint,
            maxPageLength: analytics === null || analytics === void 0 ? void 0 : analytics.maxPageLength,
            sessionizationDomain: analytics === null || analytics === void 0 ? void 0 : analytics.sessionizationDomain
        });
        analyticsReporter === null || analyticsReporter === void 0 ? void 0 : (_analyticsReporter_methodName = analyticsReporter[methodName]) === null || _analyticsReporter_methodName === void 0 ? void 0 : _analyticsReporter_methodName.call(analyticsReporter, eventName, buildParams(config, parameters));
    };
};
export const action = method('action');
export const link = method('link');
export const modal = method('modal');
export const track = method('track');
export const viewed = method('viewed');

//# sourceMappingURL=analytics.server.js.map